import React, { FC } from 'react'
//@ts-ignore-next-line
import X from '../../../images/blackx.svg'

export interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  headerText?: string
  useCustomHeader?: boolean
  bodyContainerStyle?: string
  childWrapperStyle?: string
  childContainerStyle?: string
}

const ContentModal: FC<ModalProps> | null = ({
  isOpen,
  onClose,
  useCustomHeader,
  headerText,
  children,
  bodyContainerStyle,
  childWrapperStyle,
  childContainerStyle
}) => {
  if (!isOpen) {
    return null
  }
  //  TODO: reduce z-index to normal level https://linear.app/rehabpath/issue/COO-203/refactor-z-index-on-components
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center pb-20 text-center sm:p-0">
        <div
          className="fixed inset-0 transition-opacity"
          aria-hidden="true"
        >
          <div className="absolute inset-0 bg-gray-900 opacity-75"></div>
        </div>
        <div
          className={`modal-contents mb-15 relative inline-block w-11/12 overflow-hidden rounded-3xl bg-white text-left  
                      align-bottom shadow-[0px_8px_8px_-4px_rgba(0,_0,_0,_0.10),_0px_0px_4px_0px_rgba(0,_0,_0,_0.08)] transition-all max-[639px]:mx-4 max-[639px]:mt-4 max-[639px]:h-full  sm:w-full sm:max-w-2xl sm:align-middle  
                      md:w-10/12${bodyContainerStyle || ''}`}
        >
          {useCustomHeader ? (
            <></>
          ) : (
            <div
              className={`flex bg-white p-4 ${
                headerText
                  ? 'w-full flex-row justify-between'
                  : 'mx-2 flex-row-reverse'
              } items-center border-b border-gray-300`}
            >
              <span className="text-ellipsis text-base font-medium text-gray-1100">
                {headerText}
              </span>
              <img
                src={X}
                alt="close"
                className="size-6 cursor-pointer rounded-md p-1 hover:bg-gray-200 active:bg-gray-300 sm:justify-end"
                onClick={onClose}
              />
            </div>
          )}
          <div
            className={`body-container max-w-screen-xl bg-white px-4 pb-4 pt-5 sm:max-h-[60vh] sm:overflow-y-auto sm:p-6 sm:pb-4 ${
              childWrapperStyle || ''
            }`}
          >
            <div className="h-full sm:flex sm:items-start">
              <div
                className={`mt-3 text-center sm:mt-0 sm:text-left ${
                  childContainerStyle || ''
                }`}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentModal
